import {createAction, props} from "@ngrx/store";
import {OrderElement} from "../../data/orderelement";

type SaveComplaintPayload = {complaint: string, order: OrderElement};

export enum ComplaintTypes {
  TRY_SAVE_COMPLAINT = '[COMPLAINT TYPE] Try Saving Complaint',
  SAVE_COMPLAINT_SUCCESS = '[COMPLAINT TYPE] Saving Complaint Success',
  SAVE_COMPLAINT_ERROR = '[COMPLAINT TYPE] Saving Complaint Error',
  SAVE_COMPLAINT_FINISHED = '[COMPLAINT TYPE] Saving Complaint finished',
}

export const complaintActions = {
  trySaveComplaint: createAction(ComplaintTypes.TRY_SAVE_COMPLAINT, props<{payload: SaveComplaintPayload}>()),
  saveComplaintSuccess: createAction(ComplaintTypes.SAVE_COMPLAINT_SUCCESS),
  saveComplaintError: createAction(ComplaintTypes.SAVE_COMPLAINT_ERROR, props<{payload: Error}>()),
  saveComplaintFinished: createAction(ComplaintTypes.SAVE_COMPLAINT_FINISHED),
} as const
